import { EventEmitter, type EventHandler } from "@/event-emitter";

export class UIListener
{
    private static instance: UIListener | null = null;

    private emitter = new EventEmitter();

    private constructor()
    {
        // Private constructor to prevent instantiation
    }

    public static getInstance(): UIListener
    {
        if (!UIListener.instance)
        {
            UIListener.instance = new UIListener();
        }

        return UIListener.instance;
    }


    public listen(event: string, handler: EventHandler): void
    {
        this.emitter.on(event, handler);
    }

    public unlisten(event: string, handler?: EventHandler): void
    {
        if (!this.emitter.eventsList.includes(event))
        {
            Logger.warn("UIListener", "Event not found:", event);

            return;
        }

        // Remove all handlers for the event
        if (handler === undefined)
        {
            this.emitter.off(event, () =>
            {
                // This is a no-op function to remove all handlers for the event
            });

            return;
        }

        this.emitter.off(event, handler);
    }

    public trigger(event: string, e: unknown): void
    {
        this.emitter.emit(event, e);
    }
}

export default UIListener.getInstance();
